import React, { FunctionComponent } from 'react';
import PureInfoBoxView from './info-box-view';
import { useDispatch, useSelector } from 'react-redux';
import { getNewUserState } from 'phoenix2/state/new-user/selectors';
import { infoBoxDismissed } from 'phoenix2/state/new-user/actions';

export const InfoBoxView: FunctionComponent = () => {
    const dispatch = useDispatch();
    const newUserState = useSelector(getNewUserState);

    return (
        <PureInfoBoxView
            error={newUserState.get('error')}
            handleClick={() => dispatch(infoBoxDismissed())}
        />
    );
};
